import {
  GuidIdAndLabel,
  GuidIdCodeAndLabel,BrandAndMarketListItem,Int32IdAndLabel
} from '../../../integrated-client/models';
import {DEFAULT_LIMIT_PAGINATION, DEFAULT_OFFSET, DEFAULT_TOTAL_ITEMS} from "../../../utils/Constants";

export interface IFiltersData {
  showDisabled?: boolean;
  relevance?: number | null;
  supplier?: GuidIdAndLabel;
  ancillary?: GuidIdAndLabel;
  airline?: GuidIdCodeAndLabel;
  brandAndMarket?: BrandAndMarketListItem;
  distributionChannels?: Array<Int32IdAndLabel>;
  allowEdit?: boolean;
  offset: number;
  limit: number;
  currentPage: number;
  total: number;
}

export class FiltersData implements IFiltersData {
  showDisabled?: boolean;
  relevance?: number | null;
  supplier?: GuidIdAndLabel
  ancillary?: GuidIdAndLabel
  airline?: GuidIdCodeAndLabel
  brandAndMarket?: BrandAndMarketListItem
  distributionChannels?: Array<Int32IdAndLabel>
  allowEdit?: boolean;
  offset: number;
  limit: number;
  currentPage: number;
  total: number;

  constructor() {
    this.offset = DEFAULT_OFFSET
    this.limit = DEFAULT_LIMIT_PAGINATION
    this.total = DEFAULT_TOTAL_ITEMS
    this.currentPage = 1
  }
}
